export default function Footer() {
    return (
        <footer className="fixed bottom-0 left-0 w-full bg-white text-black border-t border-gray-300 z-10">
            <div className="container mx-auto max-w-6xl px-4 py-6 flex flex-col md:flex-row items-center justify-between">
                <p className="text-sm text-gray-600">&copy; {new Date().getFullYear()} Amidex LLC. All rights reserved.</p>
                <div className="flex space-x-4 mt-4 md:mt-0">
                    <a href="/amii/privacy-policy" className="text-sm text-gray-600 hover:text-black">Privacy Policy</a>
                    <a href="/amii/support" className="text-sm text-gray-600 hover:text-black">Support</a>
                </div>
            </div>
        </footer>
    )
}
